// extracted by mini-css-extract-plugin
export default {"flash-coupon__code":"flash-coupon__code--2oI7u","flash-coupon__time":"flash-coupon__time--vpwA6"};
    if(module.hot) {
      // 1747648152387
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  